export { i18nTime } from './time';
